import { Link, router } from "@inertiajs/react"
import { Layout } from "@/components/layouts/Layout"
import { AgentForm } from "./Form"

export default function AgentsNew({ workspace_slug }) {
  function handleSubmit(data) {
    router.post(`/${workspace_slug}/agents`, { agent: data })
  }

  return (
    <Layout>
      <h1 className="text-2xl font-bold mb-6">New Agent</h1>

      <AgentForm
        onSubmit={handleSubmit}
        submitLabel="Create agent"
      />

      <p className="mt-4">
        <Link href={`/${workspace_slug}/agents`} className="text-blue-600 hover:underline">
          Back to agents
        </Link>
      </p>
    </Layout>
  )
}
